import React, { Suspense } from "react";
import {
    Routes,
    Route,
    HashRouter,
    BrowserRouter as Router
} from "react-router-dom";
import { useDispatch } from 'react-redux';
import { PrivateRoute } from "./PrivateRoute";
import { checkToken } from '../actions/auth.actions';
import { Loading } from "../views/Loading";

// Containers
const Layout = React.lazy(() => import('../components/template/Layout'))

// Pages
const Login = React.lazy(() => import('../views/Login'))
const RecoveryPassword = React.lazy(() => import('../views/RecoveryPassword'))
const PoliticaPrivacidad = React.lazy(() => import('../views/PoliticaPrivacidad'))
const NetworkError = React.lazy(() => import('../views/NetworkError'))
const Page503 = React.lazy(() => import('../views/Page503'))

export const AppRouter = () => {

    const dispatch = useDispatch();

    const token = localStorage.getItem('token');
    if (token) {
        dispatch(checkToken(token));
    }
    
    return (
        <Router>
            <Suspense fallback={<Loading />}>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/recovery" element={<RecoveryPassword />} />
                    <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
                    <Route path="/networkError" element={<NetworkError />} />
                    <Route path="/page503" element={<Page503 />} />
                    <Route path="/*" element={<PrivateRoute component={Layout} />} />
                </Routes>
            </Suspense>
        </Router>
    )
}